import { useState, useEffect } from "react";
import { getAdminInfo } from "../api";
import { hasAddon, COMPANY_ADDONS } from "../utils/addons";
import { User } from "../types/types";

interface UseAddonAccessReturn {
    user: User | null;
    hasAccess: boolean;
    loading: boolean;
    error: string | null;
}

export const useAddonAccess = (requiredAddon: keyof typeof COMPANY_ADDONS): UseAddonAccessReturn => {
    const [user, setUser] = useState<User | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const fetchUser = async () => {
            const token = localStorage.getItem("token");
            if (!token) {
                setError("No authentication token found");
                setLoading(false);
                return;
            }

            try {
                const response = await getAdminInfo({ token });
                if (!response) {
                    setError("Failed to fetch user information");
                } else {
                    setUser(response);
                }
            } catch (err) {
                console.error("Error fetching user:", err);
                setError("Failed to fetch user information");
            } finally {
                setLoading(false);
            }
        };

        fetchUser();
    }, []);

    const hasAccess = user?.cmpany ? hasAddon(user.cmpany, COMPANY_ADDONS[requiredAddon]) : false;

    return {
        user,
        hasAccess,
        loading,
        error,
    };
};
